export default __webpack_public_path__ + "static/gear_b.981ac4f592acd24530ebd4115fdafb92.svg";